import { agentBodySrc } from "@/components/agents/agentPersonas";
import type { RankRailTile } from "@/components/home/RankRail";
import { cardArtSrc, cardSerialArtSrc } from "@/lib/cardArt";
import { finishMeta } from "@/lib/cards";
import { HOME_AGENTS } from "@/lib/homeAgents";
import { findOripaPack, type RecentPull } from "@/lib/renewal/oripa";

/**
 * oripa RECENT_PULLS 1건 → RankRail 타일 — 홈 LIVE PULLS(전역)와 팩 상세
 * Recent pulls(팩 필터)가 같은 매핑을 공유한다. 이미지는 시리얼 아트 →
 * 대표 아트 → 전신 폴백 순, 하단 행 = [출처 팩명 · 상대시간](§2 변형).
 */
export function pullTile(pull: RecentPull): RankRailTile {
  const agent = HOME_AGENTS.find((entry) => entry.agentId === pull.agentId);
  const name = agent?.name ?? pull.agentId;
  const meta = finishMeta(pull.finish);
  const art =
    cardSerialArtSrc(pull.agentId, pull.finish, pull.serial) ??
    cardArtSrc(pull.agentId, pull.finish);
  return {
    key: pull.id,
    image: art ? (
      <img
        src={art}
        // 레일 타일은 ≤168px — @2x(1446px)는 8배 오버샘플이라 1x만 사용(홈 이미지 전송량 절감)
        alt={`${meta.label} — ${name}`}
        loading="lazy"
        draggable={false}
        className="h-full w-full object-cover"
      />
    ) : (
      <img
        src={agentBodySrc(name)}
        alt={`${meta.label} — ${name}`}
        loading="lazy"
        draggable={false}
        className="h-full w-full object-contain object-bottom px-2 pt-2"
      />
    ),
    // 자기 자신(홈/팩 상세)이 아닌 카드 상세로 — catalog id 규약 `${agentId}:${finish}` (lib/cards parseCardId)
    to: `/cards/${pull.agentId}:${pull.finish}`,
    name: `${meta.label} — ${name}${pull.serial ? ` #${pull.serial}` : ""}`,
    source: findOripaPack(pull.packId)?.name ?? pull.packId,
    stat: pull.pulledAgo,
  };
}
